var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 91,
    viewBox: "0 0 89 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M69.4623 36.5264L52.6467 19.6658C52.3922 16.0103 53.2633 12.3646 55.1427 9.21896C57.0222 6.07333 59.8198 3.57865 63.1593 2.07047C66.4989 0.562282 70.2202 0.11292 73.8228 0.782819C77.4253 1.45272 80.7364 3.20975 83.3105 5.8176C85.9099 8.39834 87.6593 11.7113 88.3247 15.3132C88.9901 18.9152 88.5398 22.6345 87.034 25.9736C85.5282 29.3127 83.0388 32.1124 79.8986 33.9982C76.7585 35.8841 73.1174 36.7661 69.4623 36.5264ZM6.96558 69.3485L48.3303 28.0287L61.0545 40.7528L19.6897 82.1176L7.01054 69.3485H6.96558ZM0.670938 82.0726L10.1579 72.5408L16.5424 78.9253L7.01054 88.4572L0.625977 82.0726H0.670938ZM43.6094 67.9996L52.6017 59.0073V90.4805H43.6094V67.9996Z",
    fill: "url(#paint0_linear_298_30679)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_30679",
    x1: 0.625977,
    y1: 45.4805,
    x2: 88.6237,
    y2: 45.6232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtist);
export default __webpack_public_path__ + "static/media/artist.a557f39dcc4bb9764dd4913f977ebd1b.svg";
export { ForwardRef as ReactComponent };